import { useState } from 'react';
import cn from 'classnames';
import LegendLogo from '../assets/images/icon-list-0.svg';
import { Box } from '@mui/system';

type Props = {
  item: {
    cmmn_cd_id?: string;
    cmmn_cd_cls_id?: string;
    cmmn_cd_abrv_nm: string;
    color: any;
    cmmn_cd_deci?: string;
    cmmn_cd_val?: string;
  }[];
  title: string;
};

const MapLegend = ({ item, title }: Props) => {
  const [hide, setHide] = useState(false);

  return (
    // <!-- 재배작물 범례창, hide : 레이어창을 닫았을 경우 추가 -->
    <div className={cn('mapLayer', { hide })}>
      {/* <!-- mapLayerTitArea : 레이어창 제목 영역 --> */}
      <div className="mapLayerTitArea">
        <div className="mapLayerTit">
          <img
            src={LegendLogo}
            alt="범례"
          />
          <span>{title}</span>
        </div>
        <button
          type="button"
          className="mapLayerTitBtn"
          onClick={() => setHide((prev) => !prev)}
        >
          <span>레이어창 버튼</span>
        </button>
      </div>
      {/* <!-- mapLayerConArea : 레이어창 내용 영역 --> */}
      <div className="mapLayerConArea">
        <ul className="mlcList">
          {item
            ? item.map((i, idx) => (
                <li key={i.cmmn_cd_id}>
                  <Box
                    className="mlcLegend"
                    sx={{
                      ':before': {
                        backgroundColor: `#${i.color}`,
                      },
                    }}
                  >
                    {i.cmmn_cd_abrv_nm}
                  </Box>
                </li>
              ))
            : null}
        </ul>
      </div>
    </div>
  );
};

export default MapLegend;
